import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function logoUrl(coin) {
  if (coin && coin.logo_path) return `${API}/files/${coin.logo_path}`;
  return null;
}

export function avatarUrl(path) {
  if (path) return `${API}/files/${path}`;
  return null;
}

export function shortAddr(a) {
  if (!a) return "";
  return `${a.slice(0, 6)}...${a.slice(-4)}`;
}

// Generate a fake Sui-style address for the demo wallet
export function genAddress() {
  const hex = "0123456789abcdef";
  let s = "0x";
  for (let i = 0; i < 40; i++) s += hex[Math.floor(Math.random() * 16)];
  return s;
}
